module.exports = __webpack_public_path__ + "img/dashboard.7f277cfd.png";